import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '#/components/LegalPage';
import { termsSections } from '#/lib/legal';
import { pageTitle } from '#/lib/site';
import { getSpace } from '#/lib/space-fn';

export const Route = createFileRoute('/algemene-voorwaarden')({
  head: ({ loaderData }) => ({
    meta: [{ title: pageTitle('Algemene Voorwaarden', loaderData?.space) }],
  }),
  loader: async () => {
    const space = await getSpace();
    return { space };
  },
  component: TermsPage,
});

function TermsPage() {
  const { space } = Route.useLoaderData();

  if (!space) return null;

  return (
    <LegalPage
      space={space}
      title="Algemene Voorwaarden"
      lastUpdated="Laatst bijgewerkt: 21 juli 2026"
      sections={termsSections(space)}
    />
  );
}
